<template>
  <v-container class="pb-0">
    <v-row>
      <v-col md="4" sm="12">
        <v-text-field
          v-model="filters.name"
          :label="$t('common.name')"
          solo
          dense
        ></v-text-field>
      </v-col>
      <v-col md="2" sm="12">
        <v-select
          v-model="filters.status"
          :items="statuses"
          :label="$t('common.selectStatus')"
          solo
          dense
        ></v-select>
      </v-col>
      <v-col md="2" sm="12">
        <v-checkbox
          class="mt-0"
          v-model="filters.new"
          :label="$t('common.new')"
          color="primary"
        ></v-checkbox>
      </v-col>
      <v-col md="2" xs="6">
        <v-btn color="default" block @click="reset()">
          {{ $t('common.reset') }}
        </v-btn>
      </v-col>
      <v-col md="2" xs="6">
        <v-btn color="primary" block @click="filter()">
          {{ $t('common.filter') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import approvalStatuses from '../../../enums/approval.statuses';
import listFilterMixin from '../../shared/mixins/list.filter.mixin';

export default {
  name: 'avatars-list-filter',
  mixins: [listFilterMixin],
  data() {
    return {
      defaultFilters: {
        name: null,
        new: false,
        status: null
      },
      statuses: [
        {
          text: this.$i18n.t('common.selectStatus'),
          value: ''
        },
        ...Object.values(approvalStatuses).map(status => ({
          text: this.$i18n.t(`common.approvalStatuses.${status}`),
          value: status
        }))
      ]
    };
  }
};
</script>
